module.exports = __webpack_public_path__ + "img/logo.97040e1f.jpeg";